import React, { PureComponent } from "react";
import Page from "../Page";

export default class RegistrationNotAllowed extends PureComponent {
    componentDidMount = () => {
    }
    
    render() {

        return (
            <Page showHeader={false} title="">
                <div className="row mt-3 text-center">
                    <div className="col">
                        <h1>Registration not allowed</h1>
                    </div>
                </div>                                
            </Page>
        );
    }
}